import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FormService {
    constructor(private _formBuilder: UntypedFormBuilder) {}

    clearAllDirtyForms() {
        let form: UntypedFormGroup = this._formBuilder.group({});
        this.bhProfileForm.next(form);
        this.bhConfigAssistsForm.next(form);
    }

    private bhProfileForm = new BehaviorSubject<UntypedFormGroup>(null);
    profileForm = this.bhProfileForm.asObservable();

    changeProfileForm(form: UntypedFormGroup) {
        this.bhProfileForm.next(form);
    }

    private bhConfigAssistsForm = new BehaviorSubject<UntypedFormGroup>(null);
    configAssistsForm = this.bhProfileForm.asObservable();

    changeConfigAssistsForm(form: UntypedFormGroup) {
        this.bhConfigAssistsForm.next(form);
    }
}
